import {JsonObject, JsonProperty} from 'json2typescript';
@JsonObject('EmailContentDimensions')
export class EmailContentDimensions {

    @JsonProperty('emailImageWidth',Number,true)
    emailImageWidth = 350;

    @JsonProperty('emailImageHeight',Number,true)
    emailImageHeight = 350;

    @JsonProperty('overallEmailWidth',Number,true)
    overallEmailWidth = 600;

    @JsonProperty('textPargrSideMargin',Number,true)
    textPargrSideMargin = 540;

    @JsonProperty('respondentPictureMaxWidth',Number,true)
    respondentPictureMaxWidth = 585;

}
